var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#06004a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.15-74.02q-27.6 0-47.86-20.27-20.27-20.26-20.27-47.86v-512.83q0-27.7 20.27-48.03 20.26-20.34 47.86-20.34h103.78v-10q.48-64.19 45.18-108.53Q415.8-886.22 480-886.22t108.89 44.34q44.7 44.34 45.18 108.53v10h103.78q27.7 0 48.03 20.34 20.34 20.33 20.34 48.03v512.83q0 27.6-20.34 47.86-20.33 20.27-48.03 20.27h-515.7ZM394.3-723.35h171.4v-10q-.48-35.61-25.17-60.05-24.68-24.45-60.53-24.45t-60.53 24.45q-24.69 24.44-25.17 60.05v10ZM600-534.98q14.67 0 24.37-9.69 9.7-9.7 9.7-24.37v-85.94h-68.14v85.94q0 14.67 9.7 24.37 9.7 9.69 24.37 9.69Zm-240 0q14.67 0 24.37-9.69 9.7-9.7 9.7-24.37v-85.94h-68.14v85.94q0 14.67 9.7 24.37 9.7 9.69 24.37 9.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingIcon);
export default __webpack_public_path__ + "static/media/shopping-icon.1a2b1ad73daf218fc61f02d82722320c.svg";
export { ForwardRef as ReactComponent };